import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import styles from './Portfolio.module.css';
import Eyebrow from '../ui/Eyebrow';

const portfolioItems = [
  {
    logo: '/agentdelta-logo-white.png',
    name: 'AgentDelta',
    subtitle: 'Human-led, AI-assisted Change Management.',
    status: 'Active',
    url: 'https://agentdelta.ai'
  },
  {
    logo: null,
    name: 'Stealth',
    subtitle: 'Announcing soon.',
    status: 'In Development'
  },
  {
    logo: null,
    name: 'Stealth',
    subtitle: 'Announcing soon.',
    status: 'In Development'
  }
];

export default function Portfolio() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.12 });

  return (
    <section className={styles.portfolio} id="portfolio" ref={ref}>
      <motion.div
        className={styles.container}
        initial={{ opacity: 0, y: 16 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        <Eyebrow>PORTFOLIO</Eyebrow>
        <h2 className={styles.heading}>Products built on the platform.</h2>
        <div className={styles.grid}>
          {portfolioItems.map((item, i) => (
            <div key={i} className={styles.card}>
              <div className={styles.cardHeader}>
                {item.logo ? (
                  <img src={item.logo} alt={item.name} className={styles.cardLogo} />
                ) : (
                  <span className={styles.cardName}>{item.name}</span>
                )}
              </div>
              <p className={styles.cardSubtitle}>{item.subtitle}</p>
              <div className={styles.cardFooter}>
                <span className={`${styles.badge} ${item.status === 'Active' ? styles.badgeActive : styles.badgeDev}`}>
                  {item.status}
                </span>
                {item.url && (
                  <a href={item.url} target="_blank" rel="noopener noreferrer" className={styles.launchLink}>
                    Launch &rarr;
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
